export default __webpack_public_path__ + "static/media/one-eco.d69f0281.svg";